import{createContext}from"react";export var RQBMaterialContext=/*#__PURE__*/createContext(null);